import { Component } from '@angular/core';
import { MainNavConfig } from '../../main-navigation/main-navigation.component';

const HERE = '/showcase/main-navigation';
const D    = '/showcase/mn-preview';

@Component({
  selector: 'app-main-navigation-showcase',
  templateUrl: './main-navigation-showcase.component.html',
  styleUrls: ['./main-navigation-showcase.component.scss']
})
export class MainNavigationShowcaseComponent {

  managerConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: D    + '/challenges',    icon: 'trophy' },
      { label: 'Dashboard',      routerLink: HERE,                    icon: 'dashboard' },
      { label: 'Manage Claims',  routerLink: D    + '/claims',        icon: 'description' },
      { label: 'Redeem Rewards', routerLink: D    + '/rewards',       icon: 'card_giftcard' },
      { label: 'Account',        routerLink: D    + '/account',       icon: 'bar_chart' },
      { label: 'Leaderboards',   routerLink: D    + '/leaderboards',  icon: 'leaderboard' },
      { label: 'Support',        routerLink: D    + '/support',       icon: 'help_outline' },
    ]
  };

  ciscoAdminConfig: MainNavConfig = {
    adminOffset: true,
    items: [
      { label: 'Challenges',     routerLink: HERE,                    icon: 'trophy' },
      { label: 'Cash Payments',  routerLink: D    + '/cash-payments', icon: 'payments' },
    ]
  };

  sellerConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: D    + '/challenges',   icon: 'extension' },
      { label: 'Dashboard',      routerLink: D    + '/dashboard',    icon: 'dashboard' },
      { label: 'My Claims',      routerLink: HERE,                   icon: 'description' },
      { label: 'Redeem Rewards', routerLink: D    + '/rewards',      icon: 'card_giftcard' },
      { label: 'Leaderboards',   routerLink: D    + '/leaderboards', icon: 'leaderboard' },
      { label: 'Support',        routerLink: D    + '/support',      icon: 'help_outline' },
    ]
  };

  pamSellerConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: D    + '/challenges',   icon: 'trophy' },
      { label: 'Dashboard',      routerLink: D    + '/dashboard',    icon: 'dashboard' },
      { label: 'Manage Claims',  routerLink: D    + '/claims',       icon: 'description' },
      { label: 'Redeem Rewards', routerLink: D    + '/rewards',      icon: 'card_giftcard' },
      { label: 'Account',        routerLink: HERE,                   icon: 'bar_chart' },
      { label: 'Leaderboards',   routerLink: D    + '/leaderboards', icon: 'leaderboard' },
      { label: 'Support',        routerLink: D    + '/support',      icon: 'help_outline' },
    ]
  };

  managerActiveConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: D    + '/challenges',   icon: 'trophy' },
      { label: 'Dashboard',      routerLink: HERE,                   icon: 'dashboard' },
      { label: 'Manage Claims',  routerLink: D    + '/claims',       icon: 'description' },
      { label: 'Redeem Rewards', routerLink: D    + '/rewards',      icon: 'card_giftcard' },
      { label: 'Account',        routerLink: D    + '/account',      icon: 'bar_chart' },
      { label: 'Leaderboards',   routerLink: D    + '/leaderboards', icon: 'leaderboard' },
      { label: 'Support',        routerLink: D    + '/support',      icon: 'help_outline' },
    ]
  };

  sellerActiveConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: D    + '/challenges',   icon: 'extension' },
      { label: 'Dashboard',      routerLink: D    + '/dashboard',    icon: 'dashboard' },
      { label: 'My Claims',      routerLink: D    + '/claims',       icon: 'description' },
      { label: 'Redeem Rewards', routerLink: HERE,                   icon: 'card_giftcard' },
      { label: 'Leaderboards',   routerLink: D    + '/leaderboards', icon: 'leaderboard' },
      { label: 'Support',        routerLink: D    + '/support',      icon: 'help_outline' },
    ]
  };

  trophyActiveConfig: MainNavConfig = {
    items: [
      { label: 'Challenges',     routerLink: HERE,                   icon: 'trophy' },
      { label: 'Dashboard',      routerLink: D    + '/dashboard',    icon: 'dashboard' },
      { label: 'Manage Claims',  routerLink: D    + '/claims',       icon: 'description' },
      { label: 'Account',        routerLink: D    + '/account',      icon: 'bar_chart' },
      { label: 'Support',        routerLink: D    + '/support',      icon: 'help_outline' },
    ]
  };
}
